import { z } from 'zod';

import { BaseStepDefinition } from './BaseStepDefinition';

export const SendLetterStepDefinition = BaseStepDefinition.extend({
  type: z.literal('sendLetter'),

  // TODO flesh this out
  letterConfig: z.object({
    recipient: z.literal('borrower'),
    contents: z.string(),
  }),
});

export type SendLetterStepDefinition = z.infer<typeof SendLetterStepDefinition>;
